import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

const DiscordFailPage = () => {
  const color = useColor();

  return (
    <Style d="column" a="center">
      <Space h="200px" />
      <img
        src="/assets/logo-syncly.svg"
        width={128}
        height={128}
        alt="syncly"
      />
      <Space h="62px" />
      <Heading type="h2">Duplicated server</Heading>
      <Space h="32px" />
      <TextStyle type="body1" color={color.gray700} weight="m">
        This discord server is currently integrated.
      </TextStyle>
      <Space h="62px" />

      <Button
        sizeType="m"
        onClick={() => {
          window.close();
        }}
      >
        Confirm
      </Button>
    </Style>
  );
};

const Style = styled(Flex)`
  text-align: center;
`;

const TextStyle = styled(Typo)`
  strong {
    color: ${(props) => props.theme.colors.primary100};
  }
`;

export default DiscordFailPage;
